"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const empty_state_1 = __importDefault(require("@atlaskit/empty-state"));
const layout_1 = __importDefault(require("@atlaskit/gatsby-theme-brisk/src/components/layout"));
const button_1 = __importDefault(require("@atlaskit/button"));
const styled_1 = __importDefault(require("@emotion/styled"));
const analytics_bridge_1 = require("@atlassian/analytics-bridge");
const VerticallyAlignedContent = styled_1.default.div `
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const GlobalError = () => {
    return (jsx_runtime_1.jsxs(analytics_bridge_1.ContextualAnalyticsData, Object.assign({ sourceType: analytics_bridge_1.SCREEN, sourceName: "error" }, { children: [jsx_runtime_1.jsx(analytics_bridge_1.FireScreenAnalytics, {}, void 0),
            jsx_runtime_1.jsx(layout_1.default, Object.assign({ title: "Something unexpected happened" }, { children: jsx_runtime_1.jsx(VerticallyAlignedContent, { children: jsx_runtime_1.jsx(empty_state_1.default, { header: "Something unexpected happened", description: "Our team has been notified, please refresh the page and try again.", primaryAction: jsx_runtime_1.jsx(button_1.default, Object.assign({ onClick: () => window.location.reload(), href: window.location.href }, { children: "Refresh" }), void 0) }, void 0) }, void 0) }), void 0)] }), void 0));
};
exports.default = GlobalError;
